import { InjectionToken } from '@angular/core';

export interface NotificationsConfig {
  timeout: number;
}

export const NOTIFICATIONS_CONFIG = new InjectionToken<NotificationsConfig>('NOTIFICATIONS_CONFIG');
